module.exports = __webpack_public_path__ + "img/list_5.c117d983.jpg";